// RxJS
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectContactRelationshipAgreementsInStore,
  selectContactRelationshipAgreementsPageLoading,
  selectCRShowInitWaitingMessage,
} from '../_selectors/contact-relationship-agreements.selectors';
export class ContactRelationshipAgreementsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectContactRelationshipAgreementsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectCRShowInitWaitingMessage));

    this.store
      .pipe(select(selectContactRelationshipAgreementsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
